import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import List from "./List";
import Edit from "./Edit";

const Manager = ({ match }) => {
    return (
        <Switch>
            <Route exact path={`${match.path}/all`} component={List} />
            <Route exact path={`${match.path}/new`} component={Edit} />
            <Route
                exact
                path={`${match.path}/all/:id`}
                component={Edit}
            />
        <Redirect from="*" to="/setting/devSetting" />
        </Switch>
    );
};

export default Manager;
